<script lang="ts">
	import type { SbValueProp } from '../types';
	import Image from '../components/image.svelte';
	import type { HTMLAttributes } from 'svelte/elements';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props extends HTMLAttributes<HTMLElement> {
		content: ISbStoryData<SbValueProp>['content'];
	}

	let { content, class: className, ...other }: Props = $props();
</script>

<article
	class={['flex flex-col', content.center_text && 'items-center', className]
		.filter(Boolean)
		.join(' ')}
	{...other}
	use:editable={content}
>
	<Image
		src={content.icon.filename}
		alt={content.icon.alt}
		title={content.icon.title}
		width={32}
		height={32}
		class="mb-3 h-8 w-8"
	/>
	<h1
		class={[
			'text-[16px]/[110%] font-semibold tracking-[-.16px] text-brown-1 lg:text-[20px]/[150%] lg:tracking-[-.2px]',
			content.center_text && 'text-balance text-center'
		]}
	>
		{content.title}
	</h1>
	{#if content.text && content.text.length > 0}
		<p
			class={[
				'mt-1 text-[14px]/[160%] text-brown-4',
				content.center_text && 'text-balance text-center'
			]}
		>
			{content.text}
		</p>
	{/if}
</article>
